import { render } from "./jober_deliverable.vue?vue&type=template&id=4cd2f477"
import script from "./jober_deliverable.vue?vue&type=script&lang=js"
export * from "./jober_deliverable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__